import * as React from "react";
import { useState } from "react";
import { Rating, Stack, Typography, Link, Box, useTheme } from "@mui/material";
import { ReviewQuestionDialog } from "./ReviewQuestionDialog";

function QuestionRating({
  question,
  includeCount = false,
  disableAdd = false,
  onSubmitted,
  ...props
}) {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(false);

  const rating = question?.rating?.rating || 0;
  const count = question?.rating?.count || 0;
  const hasReviewed = !!question?.userReview;

  return (
    <Stack direction="column" spacing={0.5} alignItems="flex-start">
      <Stack direction="row" spacing={0.5}>
        <Rating value={rating} precision={0.1} readOnly {...props} />
        {includeCount && (
          <Box sx={{ position: "relative", top: 2 }}>
            <Typography>({count})</Typography>
          </Box>
        )}

        {!disableAdd && (
          <Box sx={{ position: "relative", top: 2 }}>
            <Link
              component="button"
              variant="body2"
              onClick={() => setDialogOpen(true)}
              sx={{
                color: theme.palette.primary.main,
              }}
            >
              {hasReviewed ? "Edit Review" : "Add Review"}
            </Link>
          </Box>
        )}
      </Stack>
      <ReviewQuestionDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        question={question}
        onSubmitted={onSubmitted}
      />
    </Stack>
  );
}

export default QuestionRating;
